import {announce} from '@github-ui/aria-live'
import {useMutation, useQueryClient} from '@github-ui/react-query'

import {LABELS} from '../constants'
import type {CreateSavedViewResponse, UpdateSavedViewVariables} from '../types'
import {
  primeSavedViewCaches,
  type SavedViewMutationOptions,
  sendSavedViewMutationJson,
} from '../utils/saved-view-mutations'

export function useUpdateSavedViewMutation({owner, repo}: SavedViewMutationOptions) {
  const queryClient = useQueryClient()

  return useMutation<CreateSavedViewResponse, Error, UpdateSavedViewVariables>({
    mutationFn: ({id, ...body}) =>
      sendSavedViewMutationJson<CreateSavedViewResponse>(
        `/${owner}/${repo}/issues/views/${encodeURIComponent(id)}.json`,
        {method: 'PUT', body},
        LABELS.views.updateError,
      ),
    onSuccess: ({savedView}) => primeSavedViewCaches({queryClient, owner, repo}, savedView),
    onError: () => announce(LABELS.views.updateError, {assertive: true}),
  })
}
